<template>
  <base-modal>
    <z-form ref="form" tag="div">
      <z-form-input :rules="{ phone: true }">
        <tel-input v-model="phone" />
      </z-form-input>
    </z-form>
    <i-button slot="footer-ok" size="large" type="success" @click="save">
      {{ $t('shared.component.button.save') }}
    </i-button>
  </base-modal>
</template>

<script>
  import BaseModal from '@shared/components/modal/modal';
  import TelInput from '@shared/components/input/input-phone-number';
  import AwesomePhoneNumber from 'awesome-phonenumber';
  import { TaskService } from '@autoinformer/services/TaskService';
  export default {
    components: { BaseModal, TelInput },
    props: {
      campaign_id: {
        type: [Number, String],
        required: true
      }
    },
    data: () => ({ phone: '' }),
    methods: {
      save() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid && new AwesomePhoneNumber(this.phone).isPossible()) {
            TaskService.createItem(this.campaign_id, { number: this.phone }).then(res =>
              this.$emit('success', res)
            );
          }
        });
      }
    }
  };
</script>
